import { render, staticRenderFns } from "./InvoicePaymentDetailsConfigurationPanel.vue?vue&type=template&id=3a9c978b&"
import script from "./InvoicePaymentDetailsConfigurationPanel.vue?vue&type=script&lang=js&"
export * from "./InvoicePaymentDetailsConfigurationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports